export default "__VITE_ASSET__CM4FVl_r__"